import {LucideIcon, formatNumber} from '@tryghost/shade/utils';
import {useNavigate} from 'react-router-dom';
import type {TeamMember} from '@/types/api';

interface TeamMemberCardProps {
    member: TeamMember;
}

export function TeamMemberCard({member}: TeamMemberCardProps) {
    const navigate = useNavigate();
    const syncedSites = member.sites.filter(site => site.sync_status === 'synced');
    const failedCount = member.sites.filter(site => site.sync_status === 'failed').length;
    const visibleSites = syncedSites.slice(0, 2);
    const remainingSites = syncedSites.length - visibleSites.length;

    return (
        <button aria-label={`Manage ${member.name}`} className="studio-team-member-card" type="button" onClick={() => navigate(`/team/${member.id}`)}>
            <span aria-hidden="true" className="studio-team-member-avatar">{member.name.charAt(0).toUpperCase()}</span>
            <div className="studio-team-member-identity">
                <div>
                    <h3>{member.name}</h3>
                    <span className={`studio-team-member-status is-${member.status}`}><i />{member.status === 'active' ? 'Active' : 'Pending'}</span>
                </div>
                <p>{member.email}</p>
            </div>

            <div className="studio-team-member-meta">
                <span className="studio-team-role">{member.role}</span>
                <span>{formatNumber(syncedSites.length)} publication{syncedSites.length === 1 ? '' : 's'}</span>
                {!!failedCount && <span className="studio-team-sync-warning"><LucideIcon.CircleAlert size={13} />{formatNumber(failedCount)} failed</span>}
            </div>

            <div className="studio-team-access">
                <span>Publication access</span>
                <div>
                    {visibleSites.length ? visibleSites.map(site => <i key={site.tenant_id}>{site.site_name}</i>) : <i>No publications assigned</i>}
                    {remainingSites > 0 && <i>+{formatNumber(remainingSites)} more</i>}
                </div>
            </div>

            <span aria-hidden="true" className="studio-team-manage"><LucideIcon.ChevronRight size={18} /></span>
        </button>
    );
}
